import React from "react";
import PropTypes from "prop-types";

function CollectionTitleItem({ name, subName }) {
    return (
        <header className="CollectionCortisTitle">
            <h1 className="CollectionCortisTitle-name">{name}</h1>
            {subName && <p className="CollectionCortisTitle-subName">{subName}</p>}
        </header>
    );
}

CollectionTitleItem.propTypes = {
    name: PropTypes.string.isRequired,
    subName: PropTypes.string,
};

export default React.memo(CollectionTitleItem);
